import Enter from './index'

export default [{
    path: '/enter',
    name:'enter',
    component: Enter
}]
